import React from "react";

// Identificação de quem sai do depósito com a coleta.
//
// Vive aqui, e não dentro de um dos modais, porque dois formulários alimentam
// o MESMO e-mail de portaria: o da expedição e o "Notificar Coleta". Copiados,
// divergiriam no primeiro ajuste — e o que a guarita confere mudaria de lugar
// dependendo de onde o operador digitou.
//
// Quando aparece, é para preencher: nome e RE são obrigatórios, porque alerta
// com identificação pela metade não autoriza ninguém. Já a decisão de notificar
// ou não é de quem chama — aqui os campos só são renderizados se for notificar.

export default function CamposColetor({ register, errors }) {

    const base = "block w-full rounded-lg px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400";
    const borda = (temErro) => temErro
        ? "border border-red-500 outline-none ring-0"
        : "border border-zinc-500 outline-none ring-0";

    return (
        <>
            <div className="flex flex-col items-start gap-1 w-full">
                <label className="block text-gray-700 font-bold whitespace-nowrap">
                    Nome do Coletor:
                </label>
                <input
                    type="text"
                    autoFocus
                    {...register("nomeColetor", { required: true, minLength: 3 })}
                    className={`${base} ${borda(errors?.nomeColetor)}`}
                />
                {errors?.nomeColetor && (
                    <p className="text-red-500 text-xs ms-2">
                        Informe o nome como está no documento
                    </p>
                )}
            </div>

            <div className="flex gap-4">
                <div className="flex flex-col items-start gap-1 w-full">
                    <label className="block text-gray-700 font-bold whitespace-nowrap">
                        RE / Documento:
                    </label>
                    <input
                        type="text"
                        {...register("reColetor", { required: true })}
                        className={`${base} ${borda(errors?.reColetor)}`}
                    />
                    {errors?.reColetor && (
                        <p className="text-red-500 text-xs ms-2">
                            Campo obrigatório
                        </p>
                    )}
                </div>

                <div className="flex flex-col items-start gap-1 w-full">
                    <label className="block text-gray-700 font-bold whitespace-nowrap">
                        Placa do Veículo:
                        <span className="font-normal text-gray-500"> (opcional)</span>
                    </label>
                    <input
                        type="text"
                        {...register("placaColetor")}
                        className={`${base} ${borda(false)} uppercase`}
                    />
                </div>
            </div>
        </>
    );
}

/** Monta o `coletor` que o backend espera a partir dos campos do formulário. */
export const coletorDoForm = (form) => ({
    nome: form.nomeColetor,
    re: form.reColetor,
    placa: form.placaColetor,
});
